import { DataProvider } from 'react-admin';
import { crmDataProvider, crmResources } from './crmDataProvider';
import {
  equipmentDataProvider,
  equipmentResources,
  equipmentSubResources,
} from './equipmentDataProvider';
import { codeTableDataProvider, codeTableResources } from './codeTableDataProvider';
import { defaultDataProvider } from './defaultDataProvider';
import { legacyDataProvider, legacyResources } from './legacyDataProvider';
import { franchiseDataProvider, franchiseResources } from './franchiseDataProvider';

// Composite data provider that routes requests to the appropriate sub-provider
export const compositeDataProvider: DataProvider = {
  getList: (resource, params) => {
    if (franchiseResources.includes(resource)) {
      return franchiseDataProvider.getList(resource, params);
    } else if (crmResources.includes(resource)) {
      return crmDataProvider.getList(resource, params);
    } else if (equipmentResources.includes(resource) || equipmentSubResources.includes(resource)) {
      return equipmentDataProvider.getList(resource, params);
    } else if (codeTableResources.includes(resource)) {
      return codeTableDataProvider.getList(resource, params);
    } else if (legacyResources.includes(resource)) {
      return legacyDataProvider.getList(resource, params);
    } else {
      return defaultDataProvider.getList(resource, params);
    }
  },

  getOne: (resource, params) => {
    if (franchiseResources.includes(resource)) {
      return franchiseDataProvider.getOne(resource, params);
    } else if (crmResources.includes(resource)) {
      return crmDataProvider.getOne(resource, params);
    } else if (equipmentResources.includes(resource) || equipmentSubResources.includes(resource)) {
      return equipmentDataProvider.getOne(resource, params);
    } else if (codeTableResources.includes(resource)) {
      return codeTableDataProvider.getOne(resource, params);
    } else if (legacyResources.includes(resource)) {
      return legacyDataProvider.getOne(resource, params);
    } else {
      return defaultDataProvider.getOne(resource, params);
    }
  },

  getMany: (resource, params) => {
    if (franchiseResources.includes(resource)) {
      return franchiseDataProvider.getMany(resource, params);
    } else if (crmResources.includes(resource)) {
      return crmDataProvider.getMany(resource, params);
    } else if (equipmentResources.includes(resource) || equipmentSubResources.includes(resource)) {
      return equipmentDataProvider.getMany(resource, params);
    } else if (codeTableResources.includes(resource)) {
      return codeTableDataProvider.getMany(resource, params);
    } else if (legacyResources.includes(resource)) {
      return legacyDataProvider.getMany(resource, params);
    } else {
      return defaultDataProvider.getMany(resource, params);
    }
  },

  getManyReference: (resource, params) => {
    if (franchiseResources.includes(resource)) {
      return franchiseDataProvider.getManyReference(resource, params);
    } else if (crmResources.includes(resource)) {
      return crmDataProvider.getManyReference(resource, params);
    } else if (equipmentResources.includes(resource) || equipmentSubResources.includes(resource)) {
      return equipmentDataProvider.getManyReference(resource, params);
    } else if (codeTableResources.includes(resource)) {
      return codeTableDataProvider.getManyReference(resource, params);
    } else if (legacyResources.includes(resource)) {
      return legacyDataProvider.getManyReference(resource, params);
    } else {
      return defaultDataProvider.getManyReference(resource, params);
    }
  },

  create: (resource, params) => {
    if (franchiseResources.includes(resource)) {
      return franchiseDataProvider.create(resource, params);
    } else if (crmResources.includes(resource)) {
      return crmDataProvider.create(resource, params);
    } else if (equipmentResources.includes(resource) || equipmentSubResources.includes(resource)) {
      return equipmentDataProvider.create(resource, params);
    } else if (codeTableResources.includes(resource)) {
      return codeTableDataProvider.create(resource, params);
    } else if (legacyResources.includes(resource)) {
      return legacyDataProvider.create(resource, params);
    } else {
      return defaultDataProvider.create(resource, params);
    }
  },

  update: (resource, params) => {
    if (franchiseResources.includes(resource)) {
      return franchiseDataProvider.update(resource, params);
    } else if (crmResources.includes(resource)) {
      return crmDataProvider.update(resource, params);
    } else if (equipmentResources.includes(resource) || equipmentSubResources.includes(resource)) {
      return equipmentDataProvider.update(resource, params);
    } else if (codeTableResources.includes(resource)) {
      return codeTableDataProvider.update(resource, params);
    } else if (legacyResources.includes(resource)) {
      return legacyDataProvider.update(resource, params);
    } else {
      return defaultDataProvider.update(resource, params);
    }
  },

  updateMany: (resource, params) => {
    if (franchiseResources.includes(resource)) {
      return franchiseDataProvider.updateMany(resource, params);
    } else if (crmResources.includes(resource)) {
      return crmDataProvider.updateMany(resource, params);
    } else if (equipmentResources.includes(resource) || equipmentSubResources.includes(resource)) {
      return equipmentDataProvider.updateMany(resource, params);
    } else if (codeTableResources.includes(resource)) {
      return codeTableDataProvider.updateMany(resource, params);
    } else if (legacyResources.includes(resource)) {
      return legacyDataProvider.updateMany(resource, params);
    } else {
      return defaultDataProvider.updateMany(resource, params);
    }
  },

  delete: (resource, params) => {
    if (franchiseResources.includes(resource)) {
      return franchiseDataProvider.delete(resource, params);
    } else if (crmResources.includes(resource)) {
      return crmDataProvider.delete(resource, params);
    } else if (equipmentResources.includes(resource) || equipmentSubResources.includes(resource)) {
      return equipmentDataProvider.delete(resource, params);
    } else if (codeTableResources.includes(resource)) {
      return codeTableDataProvider.delete(resource, params);
    } else if (legacyResources.includes(resource)) {
      return legacyDataProvider.delete(resource, params);
    } else {
      return defaultDataProvider.delete(resource, params);
    }
  },

  deleteMany: (resource, params) => {
    if (franchiseResources.includes(resource)) {
      return franchiseDataProvider.deleteMany(resource, params);
    } else if (crmResources.includes(resource)) {
      return crmDataProvider.deleteMany(resource, params);
    } else if (equipmentResources.includes(resource) || equipmentSubResources.includes(resource)) {
      return equipmentDataProvider.deleteMany(resource, params);
    } else if (codeTableResources.includes(resource)) {
      return codeTableDataProvider.deleteMany(resource, params);
    } else if (legacyResources.includes(resource)) {
      return legacyDataProvider.deleteMany(resource, params);
    } else {
      return defaultDataProvider.deleteMany(resource, params);
    }
  },
};
